import { useNavigate } from "react-router-dom";
import { RouteConstant } from "../../util/constant/RouteConstant";

export default function Error404() {
  const navigate = useNavigate();
  return (
    <body>
      <div className="utility-page_component">
        <div className="utility-page_form-block w-form">
          <img
            src="https://d3e54v103j8qbb.cloudfront.net/static/page-not-found.211a85e40c.svg"
            alt=""
            className="utility-page_image"
          />
          <h3>Page Not Found</h3>
          <div>
            The page you are looking for doesn&#x27;t exist or has been moved
          </div>
          <a
            onClick={() => navigate(RouteConstant.dashboard.dashboard.path)}
            className="button w-button"
          >
            Go Home
          </a>
        </div>
      </div>
    </body>
  );
}
